import * as Yup from 'yup';

const materialSchema = Yup.object().shape({
  name: Yup.string().required('Material name is required'),
  url: Yup.string().url('Must be a valid URL').required('Material URL is required'),
  // ✅ FIX: Added 'video' to match the backend model
  type: Yup.string().oneOf(['pdf', 'document', 'other', 'video']).required('Material type is required'),
});

const moduleSchema = Yup.object().shape({
  title: Yup.string().required('Module title is required'),
  description: Yup.string().required('Module description is required'),
  materials: Yup.array().of(materialSchema).optional(),
});

export const createCourseSchema = Yup.object({
  title: Yup.string()
    .required('Course title is required')
    .min(5, 'Title must be at least 5 characters'),
  description: Yup.string()
    .required('Course description is required')
    .min(50, 'Description must be at least 50 characters'),
  
  // ✅ FIX: Added back the optional price validation
  price: Yup.number()
    .typeError('Price must be a number')
    .min(0, 'Price cannot be negative')
    .optional(), // Making it optional, not required

  duration: Yup.string().required('Duration is required'),
  image: Yup.string().url('Must be a valid image URL').optional(),
  modules: Yup.array().of(moduleSchema).optional(),
  published: Yup.boolean().required(),
});